import React, { useState } from 'react';
import cn from 'classnames';

import SalonModal from 'components/dialog/SalonModal.component';
import Button from 'components/form/Button.component';
import CheckboxInput from 'components/form/CheckboxInput.component';
import Icon from 'components/generic/Icon.component';
import IconStatus from 'components/generic/IconStatus.component';
import Space from 'components/generic/Space.component';
import CurrencySign from 'components/price/CurrencySign.component';
import ELID from 'constants/elid.const';
import CHARGE_TYPE from 'constants/payment/chargeType.const';

import CN from './DepositBankedNoShowModal.module.scss';

const DepositBankedNoShowModal = ({
  depositData,
  userName,
  clientHasCard,
  onRequestClose,
  onConfirmCharge,
  isOpen,
}) => {
  const [chargeType, setChargeType] = useState(CHARGE_TYPE.noShowBank);
  const [refundModalShow, setRefundModalShow] = useState(false);
  const [confirmClicked, setConfirmClicked] = useState(false);

  const handleRadioChange = (event) => {
    const newValue = event.currentTarget.getAttribute('data-value');
    setChargeType(newValue);
  };

  const handleRequestClose = () => {
    if (refundModalShow) {
      setRefundModalShow(false);
    } else {
      onRequestClose();
    }
  };

  const handleConfirmClick = () => {
    if (confirmClicked && chargeType !== CHARGE_TYPE.refund) {
      return;
    }
    if (chargeType !== CHARGE_TYPE.refund) {
      setConfirmClicked(true);
    } else if (refundModalShow) {
      setConfirmClicked(true);
    }
    if (chargeType === CHARGE_TYPE.refund && !refundModalShow) {
      setRefundModalShow(true);
    } else {
      onConfirmCharge(depositData, 0, chargeType);
    }
  };
  const hasDeposit = !refundModalShow && depositData;

  return (
    <SalonModal tag="DepositBankedNoShowModal__modal" isOpen={isOpen} withFooter isHighlighted={!depositData}>
      <SalonModal.Body>
        {refundModalShow && (
          <IconStatus variant="alert" width="lg">
            <Icon variant="alert" width="l1" />
          </IconStatus>
        )}
        <div className={CN.modalText}>
          {refundModalShow && depositData?.source === 'online' && (
            <div className={CN.modalTextBig}>
              <Space>
                Are you sure you want to <div className={CN.modalTexError}>refund</div> the deposit of
              </Space>
              <div className={CN.modalTexFocused}>
                <CurrencySign value={depositData.amount} />
              </div>
              to the client’s card ending {clientHasCard}.
            </div>
          )}

          {refundModalShow && depositData?.source === 'card' && (
            <div className={CN.modalTextBig}>
              <Space>
                Are you sure you want to <div className={CN.modalTexError}>refund</div> the deposit of
              </Space>
              <div className={CN.modalTexFocused}>
                <CurrencySign value={depositData.amount} />
              </div>
              to the client via a card machine in-store.
            </div>
          )}
          {refundModalShow && depositData?.source === 'cash' && (
            <div className={CN.modalTextBig}>
              <Space>
                Are you sure you want to <div className={CN.modalTexError}>refund</div> the deposit of
              </Space>
              <div className={CN.modalTexFocused}>
                <CurrencySign value={depositData.amount} />
              </div>
              to the client in cash.
            </div>
          )}
        </div>
        {!depositData && (
          <div>
            <IconStatus variant="warning" width="lg">
              <Icon variant="handDownRed" width="l1" />
            </IconStatus>
            <div className={CN.modalContent}>
              <div className={CN.modalTitle}>Confirm no-show</div>
              <div className={CN.modalText}>This slot will become available for other clients to book.</div>
              <div className={CN.textAlert}>
                Get protection from last minute no-shows by enabling Online Deposits in Online Booking & Payments.
              </div>
            </div>
          </div>
        )}

        {hasDeposit && (
          <div className="form-body">
            <IconStatus variant="info" width="lg">
              <Icon variant="currency" width="l1" variantInvertDark />
            </IconStatus>
            <div className={CN.modalContent}>
              <div className={CN.modalTitle}>
                {userName.split(' ')[0]} has paid a deposit of
                <div className={CN.highlighted}>
                  <CurrencySign value={depositData.amount} />
                </div>
              </div>
              <div className={CN.modalText}>Would you like to:</div>
              <br />
              <div
                data-value={CHARGE_TYPE.noShowBank}
                onClick={(event) => handleRadioChange(event)}
                className={cn({
                  [CN.checkboxContainer]: true,
                  [CN.selected]: chargeType === CHARGE_TYPE.noShowBank,
                })}
              >
                <CheckboxInput variant="option" checked={chargeType === CHARGE_TYPE.noShowBank}>
                  <span className={CN.cbText}>Keep the deposit as a no-show fee</span>
                </CheckboxInput>
              </div>
              <div
                data-value={CHARGE_TYPE.keep}
                onClick={(event) => handleRadioChange(event)}
                className={cn({
                  [CN.checkboxContainer]: true,
                  [CN.selected]: chargeType === CHARGE_TYPE.keep,
                })}
              >
                <CheckboxInput variant="option" checked={chargeType === CHARGE_TYPE.keep}>
                  <span className={CN.cbText}>Hold deposit as credit on the client's account</span>
                </CheckboxInput>
              </div>
              <div
                data-value={CHARGE_TYPE.refund}
                onClick={(event) => handleRadioChange(event)}
                className={cn({
                  [CN.checkboxContainer]: true,
                  [CN.selected]: chargeType === CHARGE_TYPE.refund,
                })}
              >
                <CheckboxInput variant="option" checked={chargeType === CHARGE_TYPE.refund}>
                  <span className={CN.cbText}>Refund the deposit</span>
                </CheckboxInput>
              </div>
            </div>
          </div>
        )}
      </SalonModal.Body>
      <SalonModal.Footer>
        <div
          className={cn({
            'form-footer': true,
            [CN.fullWidth]: true,
          })}
          data-find-me-as={ELID.findMeAsFormFooter}
        >
          <div className={CN.modalButtons}>
            <Button variant="outlineForce" onClick={handleRequestClose} xSpace>
              GO BACK
            </Button>
            <Button
              variant={refundModalShow ? 'primaryForce' : hasDeposit ? 'primaryForce' : 'alert'}
              onClick={handleConfirmClick}
              disabled={confirmClicked}
              xSpace
            >
              {refundModalShow ? 'REFUND DEPOSIT' : hasDeposit ? 'CONFIRM' : 'MARK AS NO-SHOW'}
            </Button>
          </div>
        </div>
      </SalonModal.Footer>
    </SalonModal>
  );
};

export default DepositBankedNoShowModal;
